import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useContext, useEffect } from 'react';
import dayjs from 'dayjs';
import styles from './RenderWeeks.module.scss.js';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { DvCalendarContext } from './context.js';

dayjs.extend(weekOfYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
function RenderWeeks(_ref) {
  var months = _ref.months,
    cbWeekHighlight = _ref.cbWeekHighlight,
    calSelection = _ref.calSelection,
    showWkSelection = _ref.showWkSelection,
    showWalCal = _ref.showWalCal,
    minWk = _ref.minWk,
    maxWk = _ref.maxWk,
    boxSz = _ref.boxSz,
    fontSz = _ref.fontSz;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    wmWeeks = _useState2[0],
    setWmWeeks = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    actualWeeks = _useState4[0],
    setActualWeeks = _useState4[1];
  var _useContext = useContext(DvCalendarContext),
    locale = _useContext.locale;
  var yearL = 'year';
  var monthL = 'month';
  var weekL = 'week';
  useEffect(function () {
    dayjs.locale(locale);
    var action = showWalCal ? getWeekNo : generateActualWeeks;
    action(months);
  }, [months, showWalCal, locale.name]);
  function getWeekNo(monthIdx) {
    var currMonth = dayjs().clone().set(monthL, monthIdx);
    var currentMonthIdx = currMonth.month();
    var currYear = currMonth.year();
    var prevYear = currYear - 1;
    var appliedYear = currentMonthIdx === 0 ? prevYear : currYear;
    var lastDayIndex = dayjs().set(monthL, currentMonthIdx).set(yearL, currYear).endOf(monthL).day();
    var currYrFebMonthStartWk = dayjs().clone().set(yearL, appliedYear).set('date', 1).set(monthL, 1).week();
    var wkkNoWithDates = [];
    var prevMonthLastWk = currMonth.clone().startOf(monthL).subtract(1, 'week');
    var prevMonthLastWkNo = prevMonthLastWk.week();
    var startWkNo = currMonth.clone().startOf(monthL).startOf(weekL);
    var lastWkNo = currMonth.clone().endOf(monthL).endOf(weekL);
    while (lastWkNo.isSameOrAfter(startWkNo)) {
      var calculateWeekNumber = function calculateWeekNumber(prevMonthLastWkNo, currYrFebMonthStartWk, lastDayIndex) {
        var val = prevMonthLastWkNo - currYrFebMonthStartWk + 1;
        if (val >= 52 && lastDayIndex !== 5) {
          return 1;
        }
        return val + 1;
      };
      wkkNoWithDates.push({
        wkNo: calculateWeekNumber(prevMonthLastWkNo, currYrFebMonthStartWk, lastDayIndex),
        dates: startWkNo
      });
      prevMonthLastWkNo++;
      startWkNo = startWkNo.clone().add(1, weekL);
    }
    setWmWeeks(wkkNoWithDates);
  }
  function generateActualWeeks(pMonth) {
    var currMonth = dayjs().set(monthL, pMonth);
    var currYear = currMonth.year();
    var _dayjs = dayjs().clone().set(monthL, pMonth).set(yearL, currYear);
    var startWeek = _dayjs.clone().startOf(monthL).startOf(weekL);
    var endWeek = _dayjs.clone().endOf(monthL).endOf(weekL);
    var weeks = [];
    while (startWeek.isSameOrBefore(endWeek, weekL)) {
      weeks.push(startWeek);
      startWeek = startWeek.clone().add(1, weekL);
    }
    setActualWeeks(weeks);
  }
  function isOutsideSelectableRange(pWeek) {
    return pWeek.isBefore(minWk, weekL) || pWeek.isAfter(maxWk, weekL) || !showWkSelection;
  }
  function isStartnEndWeek(pWeek, start, end) {
    return pWeek.startOf(weekL).isSame(start, 'day') || pWeek.endOf(weekL).isSame(end, 'day');
  }
  function isWeekInRange(pWeek, start, end) {
    return pWeek.isSameOrAfter(start, 'day') && pWeek.isSameOrBefore(end, 'day');
  }
  function addWeekStyles(pWeek) {
    if (isOutsideSelectableRange(pWeek)) {
      return "".concat(styles.block, " ").concat(styles.disabled, " ").concat(styles.defaultCursor);
    }
    if (showWkSelection) {
      var start = calSelection.start,
        end = calSelection.end;
      if (start && end) {
        if (isStartnEndWeek(pWeek, start, end)) {
          return "".concat(styles.block, " ").concat(styles.range);
        }

        /** Hightlight the week number vertically */
        if (isWeekInRange(pWeek, start, end)) {
          return "".concat(styles.block, " ").concat(styles.daySelected);
        }
      }
    }
    return styles.block;
  }
  function handleWeekSelection(actualWk, wk) {
    if (!showWkSelection) {
      return;
    }
    if (actualWk.isSameOrAfter(minWk, weekL) && actualWk.isSameOrBefore(maxWk, weekL)) {
      cbWeekHighlight(actualWk, wk);
    }
  }
  function addWkBgStyle(pWeek) {
    if (showWkSelection) {
      var start = calSelection.start,
        end = calSelection.end;
      if (![start, end].includes(undefined)) {
        if (pWeek.startOf(weekL).isSame(start, 'day')) {
          return "".concat(styles.dayBg, " ").concat(styles.weekBgBorderStart, " ").concat(styles.pointerCursor);
        }
        if (pWeek.endOf(weekL).isSame(end, 'day')) {
          return "".concat(styles.dayBg, " ").concat(styles.weekBgBorderEnd, " ").concat(styles.pointerCursor);
        }
      }
    }
    return "".concat(styles.dayTransparent, " ").concat(styles.pointerCursor);
  }
  if (!showWalCal) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: styles.flexCol
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles.dayHeader,
      style: {
        width: boxSz,
        height: boxSz,
        fontSize: fontSz
      }
    }, "WK"), actualWeeks.map(function (wk, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: addWkBgStyle(actualWeeks[index]),
        key: wk.week()
      }, /*#__PURE__*/React__default.createElement("div", {
        className: addWeekStyles(actualWeeks[index]),
        onClick: function onClick() {
          return handleWeekSelection(actualWeeks[index], wk.week());
        },
        role: "button",
        onKeyDown: function onKeyDown() {
          return handleWeekSelection(actualWeeks[index], wk.week());
        },
        tabIndex: 0,
        style: {
          width: boxSz,
          height: boxSz,
          fontSize: fontSz
        }
      }, wk.week()));
    }));
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.flexCol
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.dayHeader,
    style: {
      width: boxSz,
      height: boxSz,
      fontSize: fontSz
    }
  }, "WK"), wmWeeks.map(function (item, idx) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: addWkBgStyle(item.dates),
      key: "".concat(item.wkNo).concat(idx)
    }, /*#__PURE__*/React__default.createElement("div", {
      id: "week-".concat(item.wkNo),
      "data-testid": "week-".concat(item.wkNo),
      className: addWeekStyles(item.dates),
      onClick: function onClick() {
        return handleWeekSelection(item.dates, item.wkNo);
      },
      role: "button",
      tabIndex: 0,
      onKeyDown: function onKeyDown() {
        return handleWeekSelection(item.dates, item.wkNo);
      },
      style: {
        width: boxSz,
        height: boxSz,
        fontSize: fontSz
      }
    }, item.wkNo));
  }));
}

export { RenderWeeks as default };
